// extracted by mini-css-extract-plugin
export default {"label":"TextInput_label__RBnup","input":"TextInput_input__fs1jn","important":"TextInput_important__IfSpL"};